import { render, staticRenderFns } from "./seasonBonusDetail2.vue?vue&type=template&id=89c1e076&scoped=true"
import script from "./commissionDetail2?vue&type=script&lang=js&external"
export * from "./commissionDetail2?vue&type=script&lang=js&external"
import style0 from "./seasonBonusDetail2.vue?vue&type=style&index=0&id=89c1e076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c1e076",
  null
  
)

export default component.exports